<template>
  <div>
    <div class="banner">
      <img
        src="@/assets/images/newlocations/savannah/banner.jpg"
        class="w100"
      />
    </div>

    <div class="cust-content">
      <div class="head-info" v-if="$i18n.locale === 'en'">
        <div class="head-title">
          SCAD Savannah — a "city of making" on the U.S. coast
        </div>
        <div class="head-desc">
          70+ historic and modern buildings, a Hollywood-style backlot,
          museum-level exhibitions, and SCADpro industry collaborations — all in
          one creative campus.
        </div>
        <div class="head-tags">
          <span class="head-tag"
            >99% employed or in grad school (within 10 months)</span
          >
          <span class="head-tag">SCADpro industry projects</span>
          <span class="head-tag">Alumni in 100+ countries</span>
        </div>
      </div>

      <div class="head-info" v-if="$i18n.locale === 'zh'">
        <div class="head-title">SCAD 萨凡纳 — 美国海岸线上的“创意之城”</div>
        <div class="head-desc">
          拥有 70
          余座历史与现代建筑，汇聚媲美好莱坞外景的电影基地、博物馆级展览空间与
          SCADpro 企业实战项目，汇聚成一座真正的沉浸式创意校园。
        </div>
        <div class="head-tags">
          <span class="head-tag"
            >99%的毕业生在毕业12个月内实现就业或继续深造</span
          >
          <span class="head-tag">SCADpro 企业实战</span>
          <span class="head-tag">全球校友遍布 100+ 个国家</span>
        </div>
      </div>
      <div class="locationMenu">
        <div class="grid-content">
          <div class="locationMenuList">
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Atlanta' ? 'active' : ''"
              @click="locationMenuItemClick('Atlanta')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_01.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">A</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">Atlanta</div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">
                  亚特兰大
                </div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Lacoste' ? 'active' : ''"
              @click="locationMenuItemClick('Lacoste')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_02.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">L</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">Lacoste</div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">
                  拉科斯特
                </div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'Savannah' ? 'active' : ''"
              @click="locationMenuItemClick('Savannah')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_03.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">S</div>
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'en'">
                  Savannah
                </div>
                <div class="nav-name" v-if="$i18n.locale === 'zh'">萨凡纳</div>
              </div>
            </div>
            <div
              class="locationMenuItem"
              :class="selectedMenu === 'SCADnow' ? 'active' : ''"
              @click="locationMenuItemClick('SCADnow')"
            >
              <div class="menu-img-item">
                <img
                  class="menu-img w100"
                  src="@/assets/images/newlocations/nav_img_04.jpg"
                  alt=""
                />
                <div class="plane"></div>
                <div class="info-box">
                  <div class="text-01">e</div>
                </div>
                <div class="nav-name">SCADnow</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="video-box">
      <video
        src="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20251103/HZ_2025-26_SCN_SCAD_Savannah.01_final.mp4"
        controls
        poster="https://scad-minisite.oss-cn-beijing.aliyuncs.com/video/20251103/HZ_2025-26_SCN_SCAD_Savannah.01_final.mp4?x-oss-process=video/snapshot,t_5000,m_fast"
      ></video>
    </div>

    <div class="cust-content">
      <div v-if="$i18n.locale === 'en'">
        <div class="grid-content content">
          <el-row class="why-box" :gutter="30">
            <el-col :xs="24" :md="12">
              <div class="content-title">Why Savannah</div>
              <div class="text flex-align-items-center">
                <ul>
                  <li>
                    <b>Immersive campus, real outcomes</b>. Study inside 70+
                    SCAD-revitalized buildings — classrooms, studios, and
                    high-tech labs that connect directly to careers.
                  </li>

                  <li>
                    <b>Backlot advantage</b>. At
                    <a href="https://sfs.scad.edu/" target="_blank"
                      >SCAD Film Studios</a
                    >: an LED volume stage and an 11-acre backlot, the largest
                    university film complex in the U.S.
                  </li>
                  <li>
                    <b>Museum-level inspiration</b>.
                    <a href="https://www.scadmoa.org/" target="_blank"
                      >SCAD Museum of Art</a
                    >
                    + signature events (<a
                      href="https://filmfest.scad.edu/"
                      target="_blank"
                      >SCAD Savannah Film Festival</a
                    >, deFINE ART, SCADstyle,
                    <a
                      href="https://x.if7x.cn/web/SCADFASHION2025/index.html"
                      target="_blank"
                      >SCAD FASHION</a
                    >) bring global leaders to campus.
                  </li>
                </ul>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://www.scadedu.cn/Academic/"
                  >Explore facilities and programs</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/savannah/04why/01.jpg"
                class="w100"
              />
            </el-col>
          </el-row>

          <div class="building-box">
            <div
              class="building-banner-swiper-container swiper-container location-banner"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in $i18n.locale === 'zh'
                    ? buildingCnBanners
                    : buildingEnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row
            class="margin-top career-box"
            style="margin-top: 60px"
            :gutter="30"
          >
            <el-col :xs="24" :md="11">
              <div class="content-title">Career pathways</div>
              <div class="text" style="margin-top: 30px">
                Through
                <a
                  href="https://www.scad.edu/about/industry-partnerships/scadpro"
                  target="_blank"
                  >SCADpro</a
                >, students solve real briefs with companies like Google, BMW,
                Nike, and Deloitte — building portfolios and networks.
              </div>
              <div class="tags">
                <a
                  href="https://www.scadedu.cn/Programs/14/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%8A%A8%E7%94%BB.html"
                  class="tag"
                  target="_blank"
                  >Animation</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/45/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%B9%B3%E9%9D%A2%E8%AE%BE%E8%AE%A1%E4%B8%8E%E8%A7%86%E8%A7%89%E4%BC%A0%E8%BE%BE.html"
                  class="tag"
                  target="_blank"
                  >Illustration</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/56/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E4%BA%92%E5%8A%A8%E8%AE%BE%E8%AE%A1%E4%B8%8E%E6%B8%B8%E6%88%8F%E5%BC%80%E5%8F%91.html"
                  class="tag"
                  target="_blank"
                  >Interative design and game development</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/31/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E6%97%B6%E8%A3%85.html"
                  class="tag"
                  target="_blank"
                  >Fashion</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/101/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E8%A7%86%E8%A7%89%E7%89%B9%E6%95%88.html"
                  class="tag"
                  target="_blank"
                  >Visual effects</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="13">
              <div
                class="career-banner-swiper-container swiper-container location-banner"
              >
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(banner, index) in careerCnBanners"
                    :key="index"
                  >
                    <div class="slide-inner">
                      <img :src="banner.src" alt="" />
                    </div>
                  </div>
                </div>

                <div class="swiper-pagination"></div>
                <img
                  class="button-prev"
                  src="@/assets/images/newlocations/img_01.png"
                  style="
                    position: absolute;
                    top: 50%;
                    left: 30px;
                    z-index: 999999;
                  "
                />

                <img
                  class="button-next"
                  src="@/assets/images/newlocations/img_02.png"
                  style="
                    position: absolute;
                    top: 50%;
                    right: 30px;
                    z-index: 999999;
                  "
                />
              </div>
            </el-col>
          </el-row>

          <el-row class="climate-box" :gutter="30">
            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/savannah/07climate/01.jpg"
                class="w100"
              />
            </el-col>

            <el-col :xs="24" :md="12" class="climate-content">
              <div class="content-title">Climate and transporation access</div>
              <div class="text flex-align-items-center">
                <ul>
                  <li>
                    <b>Climate</b>: Similar to Guangzhou or Xiamen, Savannah has
                    a subtropical climate with mild winters and pleasant springs
                    — ideal for outdoor study and film production year-round.
                  </li>

                  <li>
                    <b>Easy Access</b>: Savannah/Hilton Head International
                    Airport (SAV) is about 25 minutes from campus, with SCAD
                    shuttle service available.
                  </li>
                  <li>
                    <b>City Transit</b>: The Bee Line bus system connects
                    academic buildings, residence halls, and downtown areas,
                    making daily commutes easy and convenient.
                  </li>
                </ul>

                <div class="tips2">
                  <b>Note</b>: Can’t visit in person? Schedule a 10-minute
                  virtual tour or 1:1 meeting with SCAD Admission advisor.
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >Chat with admission</a
                >
              </div>
            </el-col>
          </el-row>

          <div class="life_community-box">
            <div class="content-title">Life and community</div>
            <div class="text">
              Walkable historic district. Study, create, and live across a
              beautiful coastal city with parks, squares, and riverside sunsets.
              Housing & support. Modern residence halls, card access, security,
              dining, and strong international student services.
            </div>

            <div
              class="lifeCommunity-banner-swiper-container swiper-container location-banner"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in $i18n.locale === 'zh'
                    ? lifeCommunityCnBanners
                    : lifeCommunityEnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row class="recognition-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="10" class="vertical-center">
              <div class="content-title">Recognition</div>
              <div class="text">
                <ul>
                  <li>World’s Greatest Places (TIME Magazine)</li>
                  <li>Top U.S. Cities (Travel + Leisure)</li>
                  <li>#1 City for Creative Professionals (Thrillist)</li>
                  <li>Best Small Cities for Filmmakers (MovieMaker)</li>
                </ul>
              </div>
            </el-col>

            <el-col :xs="24" :md="14">
              <img
                class="w100"
                src="@/assets/images/newlocations/savannah/09recognition/01.jpg"
              />
            </el-col>
          </el-row>

          <el-row class="support-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="24" class="vertical-center">
              <div class="content-title">International support</div>
              <div class="text">
                <div class="support-title">
                  How does SCAD support international students?
                </div>
                <div class="support-text">
                  SCAD welcomes students from 100+ countries with full support
                  in visas, onboarding, housing, and academics.
                  <br />
                  Through the
                  <a
                    href="https://www.scad.edu/life/international-student-life/international-student-resources"
                    target="_blank"
                    >SCAD International Student Services Office (ISSO)</a
                  >, students receive personalized guidance before arrival,
                  during study, and after graduation — including cultural
                  events, advising, and career mentorship.
                </div>
                <div class="line"></div>

                <div class="support-title">
                  Can parents join info sessions remotely?
                </div>
                <div class="support-text">
                  Yes. Parents and guardians are welcome to join our virtual
                  info sessions or book a 1:1 Chinese-language consultation with
                  SCAD admission advisers. Sessions include introductions,
                  career outcomes, and application guidance.
                </div>
                <div class="line"></div>
                <div class="support-title">
                  What are the application timelines?
                </div>
                <div class="support-text">
                  New students may begin in fall (September), winter (January),
                  spring (March), or summer (June). <br />
                  Admission is selective — applying early ensures full
                  consideration for programs and scholarships.
                </div>
                <div class="line"></div>
              </div>
            </el-col>
          </el-row>

          <el-row class="scad-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="16">
              <div class="content-title">Start your SCAD journey</div>
              <div class="text">
                Click the 'Chat with Admission' to request program information
                or book a 1:1 consultation with a SCAD admission adviser. Our
                team responds in 2 business days with your Chinese info pack
                (program list + timeline).
              </div>
            </el-col>

            <el-col :xs="24" :md="8" class="vertical-center2">
              <div class="text">
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >Chat with admission</a
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div v-if="$i18n.locale === 'zh'">
        <div class="grid-content content">
          <el-row class="why-box" :gutter="30">
            <el-col :xs="24" :md="12">
              <div class="content-title">为什么选择萨凡纳</div>
              <div class="text flex-align-items-center">
                <ul>
                  <li>
                    <b>沉浸式校园，铸造真实成果</b>。 由 SCAD 修复与建设的 70
                    余座教学建筑，集教室、工作室与高科技实验室于一体，让学业训练与职业实践无缝衔接。
                  </li>

                  <li>
                    <b>好莱坞级别片场，启发无限创作</b>。<a
                      href="https://sfs.scad.edu/"
                      target="_blank"
                      >SCAD Film Studios</a
                    >
                    配备 LED 虚拟制作影棚与占地约 44,515
                    平方米的外景基地，是美国规模最大、功能最完备的大学电影制作综合体之一。
                  </li>
                  <li>
                    <b>博物馆级灵感，触手可及</b>。<a
                      href="https://www.scadmoa.org/"
                      target="_blank"
                      >SCAD Museum of Art</a
                    >
                    艺术博物馆及一系列标志性活动——如
                    <a href="https://filmfest.scad.edu/" target="_blank"
                      >SCAD 萨凡纳电影节</a
                    >、deFINE ART 艺术周、SCADstyle 与
                    <a
                      href="https://x.if7x.cn/web/SCADFASHION2025/index.html"
                      target="_blank"
                      >SCAD 时装秀</a
                    >——将行业领袖与学生创意汇聚于同一舞台。
                  </li>
                </ul>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://www.scadedu.cn/Academic/"
                  >探索校园设施与学位课程</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/savannah/04why/01.jpg"
                class="w100"
              />
            </el-col>
          </el-row>

          <div class="building-box">
            <div
              class="building-banner-swiper-container swiper-container location-banner"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in $i18n.locale === 'zh'
                    ? buildingCnBanners
                    : buildingEnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row
            class="margin-top career-box"
            style="margin-top: 60px"
            :gutter="30"
          >
            <el-col :xs="24" :md="11">
              <div class="content-title">职业方向</div>
              <div class="text" style="margin-top: 30px">
                通过
                <a
                  href="https://www.scad.edu/about/industry-partnerships/scadpro"
                  target="_blank"
                  >SCADpro</a
                >，学生为谷歌、宝马BMW、CBS
                体育频道、德勤等企业解决真实课题，累积作品与人脉。
              </div>
              <div class="tags">
                <a
                  href="https://www.scadedu.cn/Programs/14/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%8A%A8%E7%94%BB.html"
                  class="tag"
                  target="_blank"
                  >动画</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/45/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E5%B9%B3%E9%9D%A2%E8%AE%BE%E8%AE%A1%E4%B8%8E%E8%A7%86%E8%A7%89%E4%BC%A0%E8%BE%BE.html"
                  class="tag"
                  target="_blank"
                  >插画</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/56/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E4%BA%92%E5%8A%A8%E8%AE%BE%E8%AE%A1%E4%B8%8E%E6%B8%B8%E6%88%8F%E5%BC%80%E5%8F%91.html"
                  class="tag"
                  target="_blank"
                  >交互设计与游戏开发</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/31/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E6%97%B6%E8%A3%85.html"
                  class="tag"
                  target="_blank"
                  >服装设计</a
                >
                <a
                  href="https://www.scadedu.cn/Programs/101/%E8%89%BA%E6%9C%AF%E7%A1%95%E5%A3%AB%20%E8%A7%86%E8%A7%89%E7%89%B9%E6%95%88.html"
                  class="tag"
                  target="_blank"
                  >视觉特效</a
                >
              </div>
            </el-col>

            <el-col :xs="24" :md="13">
              <div
                class="career-banner-swiper-container swiper-container location-banner"
              >
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(banner, index) in $i18n.locale === 'zh'
                      ? careerCnBanners
                      : careerEnBanners"
                    :key="index"
                  >
                    <div class="slide-inner">
                      <img :src="banner.src" alt="" />
                    </div>
                  </div>
                </div>

                <div class="swiper-pagination"></div>
                <img
                  class="button-prev"
                  src="@/assets/images/newlocations/img_01.png"
                  style="
                    position: absolute;
                    top: 50%;
                    left: 30px;
                    z-index: 999999;
                  "
                />

                <img
                  class="button-next"
                  src="@/assets/images/newlocations/img_02.png"
                  style="
                    position: absolute;
                    top: 50%;
                    right: 30px;
                    z-index: 999999;
                  "
                />
              </div>
            </el-col>
          </el-row>

          <el-row class="climate-box" :gutter="30">
            <el-col :xs="24" :md="12">
              <img
                src="@/assets/images/newlocations/savannah/07climate/01.jpg"
                class="w100"
              />
            </el-col>

            <el-col :xs="24" :md="12" class="climate-content">
              <div class="content-title">气候与交通</div>
              <div class="text flex-align-items-center">
                <ul>
                  <li>
                    <b>季节气候</b
                    >：与广州、厦门相似，属亚热带气候，冬季温和，春季宜人，全年适合户外创作与外景拍摄。
                  </li>

                  <li>
                    <b>便携抵达</b>：萨凡纳/希尔顿黑德国际机场（SAV）距校园约 25
                    分钟车程，设有 SCAD 校车接送。
                  </li>
                  <li>
                    <b>城市通勤</b>：Bee Line
                    校园巴士贯穿主要教学楼、学生公寓与市中心，学生可轻松往返课堂、学生公寓与城市生活区。
                  </li>
                </ul>

                <div class="tips2">
                  <b>温馨提示</b>：
                  无法亲临校园？预约一场10分钟的虚拟导览，或与SCAD招生顾问一对一交流。
                </div>
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >预约专属 SCAD 招生官咨询</a
                >
              </div>
            </el-col>
          </el-row>

          <div class="life_community-box">
            <div class="content-title">学习与生活</div>
            <div class="text">
              步行友好的历史城区，让学习、创作与生活融为一体。 <br />
              海滨城市萨凡纳拥有绿树成荫的公园、宁静的广场与迷人的河畔落日，处处都散发着艺术与灵感的气息。<br />
              现代化宿舍设施安全便捷，刷卡出入、安保周全，餐饮设施一应俱全。<br />
              SCAD
              国际学生服务团队提供全方位支持，让每位学子都能安心求学、从容生活。
            </div>

            <div
              class="lifeCommunity-banner-swiper-container swiper-container location-banner"
            >
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="(banner, index) in $i18n.locale === 'zh'
                    ? lifeCommunityCnBanners
                    : lifeCommunityEnBanners"
                  :key="index"
                >
                  <div class="slide-inner">
                    <img :src="banner.src" alt="" />
                  </div>
                </div>
              </div>

              <div class="swiper-pagination"></div>
              <img
                class="button-prev"
                src="@/assets/images/newlocations/img_01.png"
                style="
                  position: absolute;
                  top: 50%;
                  left: 30px;
                  z-index: 999999;
                "
              />

              <img
                class="button-next"
                src="@/assets/images/newlocations/img_02.png"
                style="
                  position: absolute;
                  top: 50%;
                  right: 30px;
                  z-index: 999999;
                "
              />
            </div>
          </div>

          <el-row class="recognition-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="10" class="vertical-center">
              <div class="content-title">城市与院校荣誉</div>
              <div class="text">
                <ul>
                  <li>全球最佳目的地 —— 《时代周刊》</li>
                  <li>
                    美国顶级城市 —— 《旅行与休闲》<i>(Travel + Leisure)</i>
                  </li>
                  <li>创意人士首选城市 —— <i>Thrillist</i></li>
                  <li>
                    影视工作者最佳小城 —— 《电影制作人》<i>(MovieMaker)</i>
                  </li>
                </ul>
              </div>
            </el-col>

            <el-col :xs="24" :md="14">
              <img
                class="w100"
                src="@/assets/images/newlocations/savannah/09recognition/01.jpg"
              />
            </el-col>
          </el-row>

          <el-row class="support-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="24" class="vertical-center">
              <div class="content-title">国际学生支持</div>
              <div class="text">
                <div class="support-title">SCAD 如何支持国际学生？</div>
                <div class="support-text">
                  SCAD 欢迎来自 100
                  多个国家的学生，提供签证、入学、住宿与学业全方位支持。<br />
                  并通过
                  <a
                    href="https://www.scad.edu/life/international-student-life/international-student-resources"
                    target="_blank"
                    >SCAD 国际学生服务办公室（ISSO）</a
                  >
                  提供从入学前到毕业后的专属指导、跨文化活动与职业辅导，助力学生在全球职场取得成功。
                </div>
                <div class="line"></div>

                <div class="support-title">家长能否远程参加资讯会？</div>
                <div class="support-text">
                  可以。家长可参加线上中文资讯会，或预约一对一招生官咨询，了解课程介绍、就业成果与申请流程。
                </div>
                <div class="line"></div>
                <div class="support-title">申请时间线是怎样的？</div>
                <div class="support-text">
                  新生可于 秋季（9 月）、冬季（1 月）、春季（3 月） 或 夏季（6
                  月） 入学。<br />
                  SCAD
                  采取择优录取，建议尽早申请，以获得课程与奖学金的充分评估机会。
                </div>
                <div class="line"></div>
              </div>
            </el-col>
          </el-row>

          <el-row class="scad-box" :gutter="30" type="flex">
            <el-col :xs="24" :md="16">
              <div class="content-title">开启你的 SCAD 之旅</div>
              <div class="text">
                填写表单即可获取课程资料，或预约与 SCAD 招生官一对一交流。<br />
                招生团队将在 2
                个工作日内回复，并发送中文资料包（含学位课程清单与申请时间线）。
              </div>
            </el-col>

            <el-col :xs="24" :md="8" class="vertical-center2">
              <div class="text">
                <a
                  target="_blank"
                  class="link-more"
                  href="https://app.jingsocial.com/microFrontend/forms/jsf-forms/details/KKnDVR7ooucGF6472t7b7M?lead_source_type=survey&lead_source_value=KKnDVR7ooucGF6472t7b7M&promotion_code=survey_qrcode&promotion_value=WDsDVditCkgnomMyhqPvRA&promotion_channel_id=NSt9kdradHzkEyw7UEsrRA&global_promotion_channel_id=3ZH8PjSow9oxzhbzfrcXAX&global_promotion_sub_channel_id=n9RQk7YyKX6he32EtHzFce&appId=wxe14b2fd0105ac9dc"
                  >预约专属 SCAD 招生官咨询</a
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle.min.js";
import "swiper/swiper-bundle.min.css";

export default {
  data: function () {
    return {
      selectedMenu: "atlanta",
      buildingCnBanners: [
        {
          src: require("@/assets/images/newlocations/savannah/05building/cn/01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/cn/02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/cn/03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/cn/04.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/cn/05.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/cn/06.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/cn/07.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/cn/08.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/cn/09.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/cn/10.jpg"),
          url: "",
        },
      ],
      buildingEnBanners: [
        {
          src: require("@/assets/images/newlocations/savannah/05building/en/01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/en/02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/en/03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/en/04.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/en/05.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/en/06.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/en/07.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/en/08.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/en/09.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/05building/en/10.jpg"),
          url: "",
        },
      ],

      careerCnBanners: [
        {
          src: require("@/assets/images/newlocations/savannah/06career/cn/01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/06career/cn/02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/06career/cn/03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/06career/cn/04.jpg"),
          url: "",
        },
      ],
      careerEnBanners: [
        {
          src: require("@/assets/images/newlocations/savannah/06career/en/01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/06career/en/02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/06career/en/03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/06career/en/04.jpg"),
          url: "",
        },
      ],
      lifeCommunityCnBanners: [
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/cn/01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/cn/02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/cn/03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/cn/04.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/cn/05.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/cn/06.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/cn/07.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/cn/08.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/cn/09.jpg"),
          url: "",
        },
      ],
      lifeCommunityEnBanners: [
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/en/01.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/en/02.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/en/03.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/en/04.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/en/05.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/en/06.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/en/07.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/en/08.jpg"),
          url: "",
        },
        {
          src: require("@/assets/images/newlocations/savannah/08life_community/en/09.jpg"),
          url: "",
        },
      ],
    };
  },
  mounted() {
    // this.selectedMenu = this.$route.params["name"];
    // var query = this.$route.query;
    // if (query.l) {
    //   this.selectedMenu = query.l;
    // }

    this.selectedMenu = this.$route.fullPath.substring(
      this.$route.fullPath.lastIndexOf("/") + 1
    );

    this.mySwiper = this.initSwiper(".building-banner-swiper-container");
    this.careerSwiper = this.initSwiper(".career-banner-swiper-container");
    this.careerSwiper = this.initSwiper(
      ".lifeCommunity-banner-swiper-container"
    );
  },
  methods: {
    locationMenuItemClick(menu) {
      // this.selectedMenu = menu;
      // this.goTop();
      window.location.href = menu;
    },
    initSwiper: function (clazz) {
      var swiperOptions = {
        loop: true,
        speed: 1000,
        autoplay: true,
        grabCursor: true,
        autoHeight: true,
        watchSlidesProgress: true,
        mousewheelControl: true,
        keyboardControl: true,
        observer: true,

        pagination: {
          el: clazz + " .swiper-pagination",
        },
        navigation: {
          nextEl: clazz + " .button-next",
          prevEl: clazz + " .button-prev",
        },
        on: {},
      };

      return new Swiper(clazz, swiperOptions);
    },
  },
};
</script>

<style scoped lang="less">
@import "../../locations.less";
</style>
